import { SnackbarContent, makeStyles } from '@material-ui/core';
import React, { ComponentType } from 'react';
import amber from '@material-ui/core/colors/amber';

const useStyles = makeStyles((theme) => ({
  warning: {
    backgroundColor: amber[200],
    color: theme.palette.getContrastText(amber[200]),
    boxShadow: theme.shadows[1],
  },
  message: {
    display: 'flex',
    alignItems: 'center',
    fontStyle: 'italic',
  },
}));

type WithoutNavigoBadgeWarningMessageProps = {};

const WithoutNavigoBadgeWarningMessage: ComponentType<WithoutNavigoBadgeWarningMessageProps> = () => {
  const classes = useStyles();

  return (
    <SnackbarContent
      className={classes.warning}
      message={
        <span className={classes.message}>
          Vous pouvez dès maintenant saisir votre numéro de carte de transport en cliquant sur "Mon compte" &gt; "Ma
          Méthode d'accès".
        </span>
      }
    />
  );
};

export default WithoutNavigoBadgeWarningMessage;
